/* istanbul ignore file */
export enum StorageTypes {
    LocalStorage = 0,
    Cookies = 1,
    SessionStorage = 2,
}
